import React from 'react';
import s from '../styles.scss';

export const Body: React.FC<React.PropsWithChildren<{}>> = (props) => (
  <section className={s.body}>{props.children}</section>
);
Body.displayName = 'Body';
